import React from 'react';
import styled from 'styled-components';
import { BUTTON_ICONS } from './Icon';
import { ProductGroupButton } from '../ProductGroupDropdown/ProductGroupButton';
import { BUTTON_SIZES, BUTTON_THEMES } from './themes';
import { ProductGroupIcon } from '../ProductGroupDropdown/ProductGroupIcon';

export const StTextLine = styled.span<{ size?: number }>`
    margin-left: ${props => (props.size ? props.size : '0.3333em')};
`;

interface Props {
    children: React.ReactNode;
    className?: string;
    dataDisplayname?: string;
    disabled?: boolean;
    icon: (typeof BUTTON_ICONS)[number];
    onClick: () => void;
    size?: (typeof BUTTON_SIZES)[number];
    theme?: (typeof BUTTON_THEMES)[number];
    title?: string;
}

export const ButtonIconTextWidthAuto = (props: Props) => {
    return (
        <ProductGroupButton
            className={props.className}
            disabled={props.disabled}
            onClick={props.onClick}
            size={props.size}
            theme={props.theme}
            title={props.title}
        >
            <ProductGroupIcon icon={props.icon} />
            <StTextLine>{props.children}</StTextLine>
        </ProductGroupButton>
    );
};
